import React, { useState } from "react";

import { isRankedTruncated, RANKED_DEFAULT_LIMIT } from "./charts.utils";
import ShowAllToggle from "./ShowAllToggle";

import type { ReactNode } from "react";

interface RankedExpansion {
  limit: number;
  actions: ReactNode;
}

function useRankedExpansion(rowCount: number): RankedExpansion {
  const [isExpanded, setIsExpanded] = useState(false);

  return {
    limit: isExpanded ? Number.POSITIVE_INFINITY : RANKED_DEFAULT_LIMIT,
    actions: isRankedTruncated(rowCount, RANKED_DEFAULT_LIMIT) ? (
      <ShowAllToggle
        isExpanded={isExpanded}
        onToggle={() => setIsExpanded((current) => !current)}
      />
    ) : undefined,
  };
}

export default useRankedExpansion;
